var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInboxEmptyState(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  props = _objectSpread({
    title: ''
  }, props);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 279 124",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#cad5db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 0H46a8 8 0 0 0-8 8v72.794a8 8 0 0 0 8 8h228V8a8 8 0 0 0-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279 93-4.568-19.276v-.001a15.353 15.353 0 0 1-.458-3.723L225 89.042l.425-.003c.595-.004 1.19.031 1.78.106z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#98a4ab",
    height: 8,
    rx: 4,
    width: 146,
    x: 54,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#98a4ab",
    height: 8,
    rx: 4,
    width: 106,
    x: 54,
    y: 64
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#98a4ab",
    height: 8,
    rx: 4,
    width: 206,
    x: 54,
    y: 40
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f1faff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 31h220a8 8 0 0 1 8 8v72.794a8 8 0 0 1-8 8H5V39a8 8 0 0 1 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 123.794 4.568-19.276v-.001c.304-1.218.458-2.468.458-3.723L54 119.836l-.425-.003c-.595-.005-1.19.03-1.78.106z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#cad5db"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 4,
    width: 146,
    x: 21,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 4,
    width: 106,
    x: 21,
    y: 95
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 4,
    width: 206,
    x: 21,
    y: 71
  })))));
}
export { SvgInboxEmptyState as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjc5IDEyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iI2NhZDVkYiI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNjYgMEg0NmE4IDggMCAwIDAtOCA4djcyLjc5NGE4IDggMCAwIDAgOCA4aDIyOFY4YTggOCAwIDAgMC04LTh6Ii8+CiAgICAgICAgICAgIDxwYXRoIGQ9Im0yNzkgOTMtNC41NjgtMTkuMjc2di0uMDAxYTE1LjM1MyAxNS4zNTMgMCAwIDEtLjQ1OC0zLjcyM0wyMjUgODkuMDQybC40MjUtLjAwM2MuNTk1LS4wMDQgMS4xOS4wMzEgMS43OC4xMDZ6Ii8+CiAgICAgICAgPC9nPgogICAgICAgIDxyZWN0IGZpbGw9IiM5OGE0YWIiIGhlaWdodD0iOCIgcng9IjQiIHdpZHRoPSIxNDYiIHg9IjU0IiB5PSIxNiIvPgogICAgICAgIDxyZWN0IGZpbGw9IiM5OGE0YWIiIGhlaWdodD0iOCIgcng9IjQiIHdpZHRoPSIxMDYiIHg9IjU0IiB5PSI2NCIvPgogICAgICAgIDxyZWN0IGZpbGw9IiM5OGE0YWIiIGhlaWdodD0iOCIgcng9IjQiIHdpZHRoPSIyMDYiIHg9IjU0IiB5PSI0MCIvPgogICAgICAgIDxnIGZpbGw9IiNmMWZhZmYiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTMgMzFoMjIwYTggOCAwIDAgMSA4IDh2NzIuNzk0YTggOCAwIDAgMS04IDhINVYzOWE4IDggMCAwIDEgOC04eiIvPgogICAgICAgICAgICA8cGF0aCBkPSJtMCAxMjMuNzk0IDQuNTY4LTE5LjI3NnYtLjAwMWMuMzA0LTEuMjE4LjQ1OC0yLjQ2OC40NTgtMy43MjNMNTQgMTE5LjgzNmwtLjQyNS0uMDAzYy0uNTk1LS4wMDUtMS4xOS4wMy0xLjc4LjEwNnoiLz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgZmlsbD0iI2NhZDVkYiI+CiAgICAgICAgICAgIDxyZWN0IGhlaWdodD0iOCIgcng9IjQiIHdpZHRoPSIxNDYiIHg9IjIxIiB5PSI0NyIvPgogICAgICAgICAgICA8cmVjdCBoZWlnaHQ9IjgiIHJ4PSI0IiB3aWR0aD0iMTA2IiB4PSIyMSIgeT0iOTUiLz4KICAgICAgICAgICAgPHJlY3QgaGVpZ2h0PSI4IiByeD0iNCIgd2lkdGg9IjIwNiIgeD0iMjEiIHk9IjcxIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";